import { render, staticRenderFns } from "./TextBlockSelectionDialog.vue?vue&type=template&id=7dac1985"
import script from "./TextBlockSelectionDialog.vue?vue&type=script&lang=js"
export * from "./TextBlockSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./TextBlockSelectionDialog.vue?vue&type=style&index=0&id=7dac1985&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports